import React from 'react';
import '../App.css';

function Error() {
  return (
    <div>
      <h1 id="test">404! This site doesn't exist.</h1>
  </div>

  );
}

export default Error;

